import { render } from "./NotFound.vue?vue&type=template&id=80af7fe4"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=80af7fe4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__